export function CostBreakdown({ quote }) {
  if (!quote) return null;
  return (
    <>
      {quote.lines?.length > 0 && (
        <div className="rounded-md border border-slate-200 overflow-hidden" data-testid="cost-breakdown">
          <div className="bg-slate-50 px-3 py-1.5 text-[10px] font-bold uppercase tracking-wider text-slate-400 flex justify-between">
            <span>Cost estimate {quote.public_holiday ? "· Public Holiday" : ""}</span>
            <span className="text-slate-600">Total ${quote.total?.toFixed(2)}</span>
          </div>
          <table className="w-full text-[11px]">
            <tbody>
              {quote.lines.map((l, i) => (
                <tr key={i} className="border-t border-slate-100">
                  <td className="px-3 py-1.5">
                    <div className="font-medium text-slate-700">{l.participant ? `${l.participant} · ` : ""}{l.group}</div>
                    <div className="text-slate-400 text-[10px]">{l.tier} · {l.item_name} <span className="font-mono">{l.item_code}</span></div>
                    {l.worker_label && <div className="text-[10px] font-semibold text-violet-600">{l.worker_label}</div>}
                  </td>
                  <td className="px-2 py-1.5 text-right tabular-nums text-slate-500">${l.effective_rate}{l.ratio > 1 ? ` (1:${l.ratio})` : ""} × {l.hours}h</td>
                  <td className="px-3 py-1.5 text-right tabular-nums font-semibold text-slate-800">${l.amount?.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {quote.warnings?.length > 0 && (
        <div className="text-[11px] text-amber-700" data-testid="billing-warnings">{quote.warnings.map((w, i) => <div key={i}>⚠ {w}</div>)}</div>
      )}
    </>
  );
}
